<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>User wise enrollment</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item">Reports</li>

              <li class="breadcrumb-item active">User wise enrollment</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <div class="btn-toolbar pull-right">
              <a
                href="javascript:void(0)"
                class="btn btn-info"
                @click="showFilter = !showFilter"
                ><i class="fa fa-filter"></i>Filter</a
              >
            </div>
            <div class="card-tools">
              <button class="btn btn-info" @click="exportFile()">
                <i class="fas fa-download"></i> Export
              </button>
            </div>
          </div>
          <form @submit.prevent="getFilterData" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="username"
                      >Username</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="username"
                        class="form-control"
                        v-model="filter.username"
                        placeholder="username"
                      />
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="course_title"
                      >Course title</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="course_title"
                        class="form-control"
                        v-model="filter.course_title"
                        placeholder="course title"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="course_id"
                      >Mobile no</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="mobile_no"
                        class="form-control"
                        v-model="filter.mobile_no"
                        placeholder="mobile_no"
                      />
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="course_id"
                      >Course ID</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="course_id"
                        class="form-control"
                        v-model="filter.course_id"
                        placeholder="course id"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-common m-2px">
                        Search
                      </button>
                      <button
                        type="reset"
                        class="btn btn-warning"
                        @click="resetFilter()"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body table-responsive-md p-0">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 150px">Username</th>
                  <th style="width: 150px">Full name</th>
                  <th style="width: 150px">Mobile no</th>
                  <th style="width: 150px">Course title</th>
                  <th style="width: 150px">Certificate title</th>
                  <th style="width: 150px">Completion(%)</th>
                  <th style="width: 150px">Enrolment at</th>
                  <th style="width: 150px">Certificate</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in items.data">
                  <td style="">{{ item.user.username }}</td>
                  <td>{{ item.user.name }}</td>
                  <td>{{ item.user.mobile_no }}</td>
                  <td>{{ item.course.course_title }}</td>
                  <td>{{ item.course.course_certificate_title }}</td>
                  <td>{{ item.course_completion_status }}</td>
                  <td>{{ item.start_time | moment }}</td>
                  <td v-if="item.course_completion_status > 90">
                    <b-button
                      class="btn btn-info"
                      @click="
                        viewCertificateImage(
                          item.certificate.certificate_image_path
                        )
                      "
                      v-if="item.certificate"
                    >
                      <i class="fas fa-eye"></i>
                    </b-button>
                    <a
                      class="btn btn-info"
                      title="Download"
                      @click.prevent="
                        downloadItem({
                          url:
                            API_ROOT_URL +
                            '/uploads/learning/' +
                            item.certificate.certificate_pdf_path,
                          label: 'certificate-' + item.user.username + '.pdf',
                        })
                      "
                      v-if="item.certificate"
                      ><i class="fas fa-download"></i>
                    </a>
                    <a
                      class="btn btn-info"
                      @click="generateCert(item.id)"
                      title="Generate Certificate"
                    >
                      <i class="fas fa-certificate"></i>
                    </a>
                  </td>
                  <td v-else></td>
                </tr>
              </tbody>
            </table>

            <div class="p-4" v-if="_.isEmpty(items.data)">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>

          <div class="card-footer">
            <vue-pagination
              :pagination="items"
              v-if="items.total > items.per_page"
            />
          </div>
        </div>
      </div>
    </section>
    <certificate-modal
      :image_path="certificate_image"
      ref="certificateViewModal"
    />
  </div>
</template>

<script>
import CertificateModal from "./components/CertificateModal";
import VuePagination from "@/components/partials/PaginationComponent";
import { LearningReportApi } from "@/services/api";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import fileDownload from "js-file-download";
import axios from "axios";

export default {
  name: "UserWiseCourseEnrollment",
  metaInfo: {
    title: "User wise enrollment | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    CertificateModal,
  },
  data: () => ({
    items: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    showFilter: false,
    certificate_image: "",
    filter: {},
    is_loading: false,
  }),
  mounted() {
    this.getItems();
  },
  methods: {
    viewCertificateImage(certificateImage) {
      if (certificateImage) {
        this.certificate_image = certificateImage;
        this.$refs.certificateViewModal.enableModal();
      } else {
        this.$toaster.error("Certificate image is not ready yet.");
      }
    },
    generateCert(enrolmentID) {
      let _this = this;
      this.is_loading = true;
      LearningReportApi.generateCertificateByAdmin(enrolmentID)
        .then((response) => {
          _this.$toaster.success(response.message);
        })
        .finally(() => {
          _this.is_loading = false;
        });
    },
    async downloadItem({ url, label }) {
      // console.log("url", url);
      // fileDownload(url, label);
      // window.location.href = url;
      window.open(url, "_blank");
    },
    getItems() {
      this.filter = JSON.parse(JSON.stringify(this.$route.query));
      if (!_.isEmpty(this.filter)) this.showFilter = true;
      this.is_loading = true;
      let params = { ...this.filter, ...this.$route.query };
      LearningReportApi.userWiseCourseEnrollment(params)
        .then((items) => {
          this.items = items
        })
        .finally(() => {
          this.is_loading = false
        });
    },
    resetFilter() {
      this.$router.push({ path: this.$route.path }).catch(() => {});
    },
    async getFilterData() {
      this.$router
        .push({
          path: this.$route.fullPath,
          query: this.filter,
        })
        .catch((err) => {
          console.log(err);
        });
    },
    exportFile: function () {
      this.is_loading = true
      axios
        .get("/reports/user-wise-course-enrollment-export", {
          params: this.filter,
          responseType: "blob",
        })
        .then((response) => {
          console.log(response.data)
          fileDownload(response.data, "user-wise-course-enrollment.xlsx")
        })
        .catch((error) => {
          console.log("error " + error)
        })
        .finally(() => {
          this.is_loading = false
        })
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },
  },
};
</script>

<style scoped>
.blink {
  animation: blinker 1.5s linear infinite;
  color: red;
  font-family: sans-serif;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
